<template>
  <v-tabs
    v-model="tabReport"
    background-color="transparent"
    color="#333"
    slider-color="transparent"
  >
    <v-tab v-for="eventData in eventsData" :key="eventData.id">{{ eventData.transName }}</v-tab>
    <v-tab-item class="pb-2" v-for="eventData in eventsData" :key="eventData.id">
      <div class="table-overflow">
        <table class="table-full">
          <thead>
          <tr>
            <td rowspan="3" class="text-center">№ п/п</td>
            <td rowspan="3" class="text-center">{{ $t('Наименование мероприятий') }}</td>
            <td rowspan="3" class="text-center">{{ $t('Ед. изм.') }}</td>
            <td colspan="2" class="text-center">{{ $t('План') }}</td>
            <td colspan="2" class="text-center">{{ $t('Факт') }}</td>
          </tr>
          <tr>
            <td rowspan="2">{{ $t('Кол-во') }}</td>
            <td class="text-center">{{ $t('Сумма (т. сом)') }}</td>
            <td rowspan="2">{{ $t('Кол-во') }}</td>
            <td class="text-center">{{ $t('Сумма (т. сом)') }}</td>
          </tr>
          <tr>
            <td class="text-center">{{ $t('софинансирования') }}</td>
            <td class="text-center">{{ $t('софинансирования') }}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, dataName, key) in eventData.events" :key="eventData.id + '_' + key">
            <td>{{ key+1 }}</td>
            <td>{{ data.event.transName }}</td>
            <td>{{ data.event.transUnit }}</td>
            <td :class="{ 'text-center': edit === false }">
              <template v-if="edit">
                <div class="size-xs ma-auto">
                  <v-text-field
                    v-model.number="data.eventData.planCount"
                    outlined
                    dense
                    type="number"
                  />
                </div>
              </template>
              <template v-else>
                {{ data.eventData.planCount }}
              </template>
            </td>
            <td :class="{ 'text-center': edit === false }">
              <template v-if="edit">
                <div class="size-xs ma-auto">
                  <v-text-field
                    v-model.number="data.eventData.planSum"
                    outlined
                    dense
                    type="number"
                  />
                </div>
              </template>
              <template v-else>
                {{ data.eventData.planSum }}
              </template>
            </td>
            <td :class="{ 'text-center': edit === false }">
              <template v-if="edit">
                <div class="size-xs ma-auto">
                  <v-text-field
                    v-model.number="data.eventData.factCount"
                    outlined
                    dense
                    type="number"
                  />
                </div>
              </template>
              <template v-else>
                {{ data.eventData.factCount }}
              </template>
            </td>
            <td :class="{ 'text-center': edit === false }">
              <template v-if="edit">
                <div class="size-xs ma-auto">
                  <v-text-field
                    v-model.number="data.eventData.factSum"
                    outlined
                    dense
                    type="number"
                  />
                </div>
              </template>
              <template v-else>
                {{ data.eventData.factSum }}
              </template>
            </td>
          </tr>
          <template v-for="child in eventData.children">
            <tr>
              <td colspan="3"><b>{{ child.transName }}</b></td>
              <td class="text-center"><b>{{ total_children_field(child.events, 'planCount') }}</b></td>
              <td class="text-center"><b>{{ total_children_field(child.events, 'planSum') }}</b></td>
              <td class="text-center"><b>{{ total_children_field(child.events, 'factCount') }}</b></td>
              <td class="text-center"><b>{{ total_children_field(child.events, 'factSum') }}</b></td>
            </tr>
            <tr v-for="(childData, childDataName, childKey) in child.events" :key="'child_' + eventData.id + '_' + childKey">
              <td>{{ childKey+1 }}</td>
              <td>{{ childData.event.transName }}</td>
              <td>{{ childData.event.transUnit }}</td>
              <td :class="{ 'text-center': edit === false }">
                <template v-if="edit">
                  <div class="size-xs ma-auto">
                    <v-text-field
                      v-model.number="childData.eventData.planCount"
                      outlined
                      dense
                      type="number"
                    />
                  </div>
                </template>
                <template v-else>
                  {{ childData.eventData.planCount }}
                </template>
              </td>
              <td :class="{ 'text-center': edit === false }">
                <template v-if="edit">
                  <div class="size-xs ma-auto">
                    <v-text-field
                      v-model.number="childData.eventData.planSum"
                      outlined
                      dense
                      type="number"
                    />
                  </div>
                </template>
                <template v-else>
                  {{ childData.eventData.planSum }}
                </template>
              </td>
              <td :class="{ 'text-center': edit === false }">
                <template v-if="edit">
                  <div class="size-xs ma-auto">
                    <v-text-field
                      v-model.number="childData.eventData.factCount"
                      outlined
                      dense
                      type="number"
                    />
                  </div>
                </template>
                <template v-else>
                  {{ childData.eventData.factCount }}
                </template>
              </td>
              <td :class="{ 'text-center': edit === false }">
                <template v-if="edit">
                  <div class="size-xs ma-auto">
                    <v-text-field
                      v-model.number="childData.eventData.factSum"
                      outlined
                      dense
                      type="number"
                    />
                  </div>
                </template>
                <template v-else>
                  {{ childData.eventData.factSum }}
                </template>
              </td>
            </tr>
          </template>
          <tr>
            <td colspan="3"><b>{{ $t('Всего') }}</b></td>
            <td class="text-center"><b>{{ total_field(eventData, 'planCount') }}</b></td>
            <td class="text-center"><b>{{ total_field(eventData, 'planSum') }}</b></td>
            <td class="text-center"><b>{{ total_field(eventData, 'factCount') }}</b></td>
            <td class="text-center"><b>{{ total_field(eventData, 'factSum') }}</b></td>
          </tr>
          </tbody>
        </table>
      </div>
    </v-tab-item>
  </v-tabs>

</template>

<script>

export default {
  props: {
    eventsData: Array|Object,
    edit: Boolean
  },
  data: () => ({
    tabReport: null,
    counter: 0
  }),
  methods: {
    total_children_field (arr, field) {
      let sum = 0
      Object.entries(arr).forEach(([eventKey, event]) => {
        const eventData = event.eventData
        if (eventData[field] !== undefined && eventData[field] !== '') {
          sum = sum + eventData[field]
        }
      })

      return parseFloat(sum.toFixed(2))
    },
    total_field (arr, field) {
      let sum = this.total_children_field(arr.events, field)

      Object.entries(arr.children).forEach(([childKey, child]) => {
        sum = sum + this.total_children_field(child.events, field)
      })

      return parseFloat(sum.toFixed(2))
    }
  }
}
</script>
